import React from 'react';
import FitCellContents from './FitCellContents';
import FitGridWidth from './FitGridWidth';
import SizeSettingsLayout from './SizeSettingsLayout';

/**
 * This can be transformed using the {@link useAutoSizeStrategy}
 * before being passed into ag-grid as an autoSizeStrategy within the
 * gridOptions
 */
const GridColumnSizeSettings = ({
  label,
  fields,
  columnSizeStrategy,
  setColumnSizeStrategy,
}: {
  label?: JSX.Element;
  fields: { key?: string; field: string; label: string }[];
  columnSizeStrategy: FleetOps.ColumnSizeStrategies.Strategy | undefined;
  setColumnSizeStrategy: React.Dispatch<
    React.SetStateAction<FleetOps.ColumnSizeStrategies.Strategy | undefined>
  >;
}) => {
  let content: JSX.Element | JSX.Element[] | null = null;
  if (columnSizeStrategy && columnSizeStrategy.type === 'fitCellContents') {
    content = (
      <FitCellContents
        fields={fields}
        columnSizeStrategy={columnSizeStrategy}
        setColumnSizeStrategy={setColumnSizeStrategy}
      />
    );
  } else if (columnSizeStrategy && columnSizeStrategy.type === 'fitGridWidth') {
    content = (
      <FitGridWidth
        fields={fields}
        columnSizeStrategy={columnSizeStrategy}
        setColumnSizeStrategy={setColumnSizeStrategy}
      />
    );
  }

  return (
    <SizeSettingsLayout
      label={label}
      columnSizeStrategy={columnSizeStrategy}
      setColumnSizeStrategy={setColumnSizeStrategy}
      children={content}
    />
  );
};

export default GridColumnSizeSettings;
